<template>
  <history-item-template
    :createTime="action.createTime"
    :creatorName="action.creatorName"
    :comment="action.data.comment"
    :vbAttachments="action.attachments"
    @downloadFile="
      ({ vbAttachment }) => $emit('downloadFile', { vbAttachment })
    "
  >
    <template #historyHeader>
      <p
        :class="[
          'action-type flex-row flex__left inline-flex',
          classColorByActionName(action.actionName),
        ]"
      >
        <i
          :class="[
            'font-size__small',
            classIconByActionName(action.actionName),
          ]"
        ></i>
        <span class="font-size__small no_wrap">
          &nbsp;{{ action.actionNameLabel }}
        </span>
      </p>
      <!--build thong tin người nhận-->
      {{ buildNameReceivers(action) }}
      {{ buildWordTemplate(action) }}
      <doc-in-receivers-info
        :categoryVBan="'doc-in'"
        :action="action"
        :actionName="action.actionName"
      ></doc-in-receivers-info>
      <!--build thong tin người nhận:end-->
    </template>
  </history-item-template>
</template>

<script>
import HistoryTemplate from "../adminstration/ketluan/history-template";
import HistoryItemTemplate from "../common/layout/history-item-template";
import DocInReceiversInfo from "./doc-in-receivers-info";
import constants from "../../constants";

export default {
  name: "doc-in-history-item",
  components: { DocInReceiversInfo, HistoryItemTemplate, HistoryTemplate },
  props: ["action"],
  methods: {
    getProcessTypeName(processType) {
      switch (processType) {
        case constants.PROCESS_TYPE.CHUTRI:
          return "(Chủ trì)";
        case constants.PROCESS_TYPE.PHOIHOP:
          return "(Phối hợp)";
        case constants.PROCESS_TYPE.NHANDEBIET:
          return "(Nhận để biết)";
        default:
          return "";
      }
    },

    buildWordTemplate(action) {
      if (
        action.dataType === "actionLog" &&
        action.dataJson &&
        action.dataJson.length > 1
      ) {
        switch (action.actionName) {
          case "chuyenXuLiDonVi":
          case "banHanh":
            return ` và ${action.dataJson.length - 1} đơn vị khác`;
          default:
            return ` và ${action.dataJson.length - 1} người khác`;
        }
      } else {
        return "";
      }
    },

    buildNameReceivers(action) {
      if (
        action.actionName &&
        action.dataType === "actionLog" &&
        action.dataJson
      ) {
        // if response array people
        if (action.dataJson.length) {
          switch (action.actionName) {
            case "cc":
              return (
                action.dataJson[0].receiverName +
                " " +
                this.getProcessTypeName(constants.PROCESS_TYPE.NHANDEBIET)
              );
            case "chuyenXuLi":
              return (
                action.dataJson[0].receiverName +
                " " +
                this.getProcessTypeName(action.dataJson[0].processType)
              );
            case "chuyenXuLiDonVi":
              return (
                (action.dataJson[0].toDeptName ||
                  action.dataJson[0].deptReceiverName) +
                " " +
                this.getProcessTypeName(action.dataJson[0].processType)
              );
            case "banHanh":
              return (
                (action.dataJson[0].deptName ||
                  action.dataJson[0].deptReceiverName) +
                " " +
                this.getProcessTypeName(action.dataJson[0].processType)
              );
            case "thuHoi":
              return (
                action.dataJson[0].receiverName ||
                action.dataJson[0].deptReceiverName
              );
            default:
              return "";
          }
        } else {
          // if dataJson is object and actionName is chuyenXuLi
          if (action.actionName === "chuyenXuLi")
            return action.dataJson.receiverName || "";
        }
      }
      return "";
    },

    classIconByActionName(actionName) {
      return actionName == "update"
        ? "fal fa-pencil-alt"
        : actionName == "insert"
        ? "fal fa-file-plus"
        : actionName == "chuyenXuLi" || actionName == "cc"
        ? "far fa-arrow-alt-circle-right"
        : actionName == "banHanh"
        ? "fal fa-check-circle"
        : actionName == "tuChoi"
        ? "fal fa-times-octagon"
        : actionName == "tuChoiTiepNhan" || actionName == "lanhDaoTuChoi"
        ? "fal fa-times-octagon"
        : actionName == "choBanHanh"
        ? "fal fa-clock"
        : actionName == "kethuc"
        ? "fal fa-calendar-check"
        : actionName == "thuHoi"
        ? "fal fa-undo"
        : actionName == "thuHoiBanHanh"
        ? "fas fa-reply-all"
        : actionName == "chuyenXuLiDonVi"
        ? "far fa-arrow-alt-circle-right"
        : "";
    },

    classColorByActionName(actionName) {
      //mockup chuyen vien van thu tu choi
      // action.actionName = 'chuyenVienTuChoi'
      //   ? 'font-size__small color__red fal fa-reply'
      //   : ''
      return actionName === "update"
        ? "color__green"
        : actionName === "insert" || actionName == "cc"
        ? "color__blue"
        : actionName === "chuyenXuLi"
        ? "color__cyan"
        : actionName === "banHanh"
        ? "color__blue"
        : actionName === "tuChoi"
        ? "color__red"
        : actionName === "tuChoiTiepNhan" || actionName === "lanhDaoTuChoi"
        ? "color__red"
        : actionName === "choBanHanh"
        ? "color__blue"
        : actionName === "kethuc"
        ? "color__green"
        : actionName === "thuHoi"
        ? "color__yellow"
        : actionName === "thuHoiBanHanh"
        ? "color__blue"
        : actionName === "chuyenXuLiDonVi"
        ? "color__blue"
        : "";
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/doc-in-history-item.vue